module.exports = __webpack_public_path__ + "441c89e6bdbe6c477c4dcf87abb9b6a8.svg";